(function () {
	const initProductAccordion = () => {
		$(document)
			.off("click.productAccordion")
			.on("click.productAccordion", ".product-about__accordion-title", function () {
				if (!$(this).hasClass("active")) {
					$(".product-about__accordion-title.active").removeClass("active");
					$(".product-about__accordion-content").stop().slideUp(200);
					$(this).addClass("active");
					$(this).next(".product-about__accordion-content").stop().slideDown(200);
				} else {
					$(this).removeClass("active");
					$(this).next(".product-about__accordion-content").stop().slideUp(200);
				}
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();